export default __webpack_public_path__ + "static/experienceBg-fde095bbf85a9c1cd7ab5ba7498b735d.png";